import React, { createContext, useState, useEffect, useContext } from 'react';
import { auth, db } from '../firebaseConfig';
import { doc, onSnapshot } from 'firebase/firestore';
import { useUser } from './UserContext'; // Depende de UserContext

// 1. Crear el contexto
const WalletContext = createContext();

// 2. Crear el Proveedor
export const WalletProvider = ({ children }) => {
  const [balances, setBalances] = useState(null);
  const [loading, setLoading] = useState(true);
  const { userData } = useUser(); // Obtiene el usuario actual

  useEffect(() => {
    let unsubscribe = () => {}; // Función de limpieza

    if (userData) {
      // Si hay un usuario, nos suscribimos a su documento de billetera
      const walletDocRef = doc(db, 'wallets', userData.uid);
      
      unsubscribe = onSnapshot(walletDocRef, (docSnap) => {
        if (docSnap.exists()) {
          // Si la billetera existe, guardamos los saldos en el estado
          setBalances(docSnap.data().balances);
        } else {
          // Esto puede pasar si la Cloud Function falla
          console.error("Error: No se encontró el documento de billetera para el usuario.");
          setBalances(null);
        }
        setLoading(false);
      }, (error) => {
        console.error("Error al escuchar la billetera:", error);
        setBalances(null);
        setLoading(false);
      });

    } else {
      // Si no hay usuario (logout), limpiamos los saldos
      setBalances(null);
      setLoading(false);
    }

    // Limpiamos la suscripción al desmontar o si el usuario cambia
    return () => unsubscribe();
    
  }, [userData]); // Se ejecuta cada vez que 'userData' cambia

  const value = {
    balances,
    loadingBalances: loading
  };

  return (
    <WalletContext.Provider value={value}>
      {children}
    </WalletContext.Provider>
  );
};
// 3. Crear un hook para consumir el contexto
export const useWallet = () => {
  return useContext(WalletContext);
};